import moment from "moment";
import { generateObjectPromoTarget } from "./utils";
import { formInitPromo } from '../../../views/Promo/formInit'
import _ from 'lodash'

export function PROMOS_REQUEST(state) {
  state;
  state.promos = {
    ...state.promos,
    isLoading: true
  };
}

export function PROMOS_SUCCESS(state, payload) {
  const data = [];
  payload.data.data.promo.rows.map(item => {
    data.push({
      promoId: item.id || "-",
      title: item.title || "-",
      budget: item.budget || "-",
      terpakai: item.terpakai || "-",
      start_date: moment(item.startDatetime).format("DD-MM-YYYY") || "-",
      end_date: moment(item.endDatetime).format("DD-MM-YYYY") || "-",
      promoType: item.promoType || "-",
      active: item.isActive
    });
    return item;
  });

  state;
  state.promos = {
    ...state.promos,
    data: data,
    count: payload.data.data.promo.count,
    status: payload.status,
    isLoading: false
  };
}

export function PROMOS_ERROR(state, payload) {
  state;
  state.promos = {
    error: true,
    errorMessage: payload,
    isLoading: false
  };
}

export function GET_PROMO_REQUEST(state) {
  state;
  state.promo = {
    ...state.promo,
    isLoading: true
  };
}
export function GET_PROMO_SUCCESS(state, payload) {
  const { promo } = payload.data.data;
  const promoTarget = generateObjectPromoTarget(promo);
  const data = {
    ...promo,
    ...promoTarget
  };
  state;
  state.promo = {
    isLoading: false,
    data: data,
    status: payload.status
  };
}
export function GET_PROMO_ERROR(state, payload) {
  state;
  state.promo = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function CREATE_PROMO_REQUEST(state) {
  state;
  state.promo = {
    ...state.promo,
    isLoading: true
  };
}
export function CREATE_PROMO_SUCCESS(state) {
  state;
  state.promo = {
    ...state.promo,
    data: _.cloneDeep(formInitPromo),
    isLoading: false,
    status: 200
  };
}
export function CREATE_PROMO_ERROR(state, payload) {
  state;
  state.promo = {
    error: true,
    errorMessage: payload,
    isLoading: false
  };
}

export function EDIT_PROMO_REQUEST(state) {
  state;
  state.promo = {
    ...state.promo,
    isLoading: true
  };
}
export function EDIT_PROMO_SUCCESS(state) {
  state;
  state.promo = {
    ...state.promo,
    data: _.cloneDeep(formInitPromo),
    isLoading: false,
    status: 200
  };
}
export function EDIT_PROMO_ERROR(state, payload) {
  state;
  state.promo = {
    error: true,
    errorMessage: payload,
    isLoading: false
  };
}

export function DELETE_PROMO_REQUEST(state) {
  state;
  state.promos = {
    ...state.promos,
    isLoading: true
  };
}
export function DELETE_PROMO_SUCCESS(state, payload) {
  let index = state.promos.data.findIndex(item => item.promoId == payload.promoId);
  state.promos.data.splice(index, 1);
  state;
  state.promos = {
    ...state.promos,
    isLoading: false,
    data: state.promos.data
  };
}
export function DELETE_PROMO_ERROR(state, payload) {
  state;
  state.promos = {
    ...state.promos,
    isLoading: false,
    status: payload.status,
    error: true,
    errorMessage: payload
  };
}
